import React from "react";
import ViewController from "../commons/base/view_controller";
import Scaffold from "../commons/scaffold/scaffold";
import SizedDiv from "../commons/ui/sized_div";
import SoldOutItemDashboardState from "./models/sold_out_item_dashboard_state";
import SoldOutItemDashboardViewModel from "./view_models/sold_out_item_dashboard_view_model";
import SoldOutDashboardTableWidget from "./widgets/sold_out_main_course_table_widget";

export default class SoldOutItemDashboardScreen extends ViewController<
    {},
    SoldOutItemDashboardState,
    SoldOutItemDashboardViewModel
> {
    interval?: NodeJS.Timer;

    constructor(props: {}) {
        super(props, new SoldOutItemDashboardViewModel());
    }

    componentDidMount(): void {
        if (!this.interval) {
            this.interval = setInterval(() => this.viewModel.loadData(), 10000);
        }
    }

    render(): React.ReactNode {
        const vm = this.vmState;
        return (
            <Scaffold
                isShowLoading={
                    vm.majorItemPerOutlet.size === 0 &&
                    vm.minorItemPerOutlet.size === 0
                }
                showErrorView={
                    vm.errorMessage
                        ? { message: vm.errorMessage, action: () => {} }
                        : undefined
                }
            >
                <div className=" bg-slate-500 overflow-x-auto min-h-screen p-5 mt-7 relative">
                    <SizedDiv height={16.0} />

                    <SoldOutDashboardTableWidget
                        title="Major"
                        soldOutMap={vm.majorItemPerOutlet}
                    />

                    <SizedDiv height={16.0} />

                    <SoldOutDashboardTableWidget
                        title="Minor"
                        soldOutMap={vm.minorItemPerOutlet}
                    />
                </div>
            </Scaffold>
        );
    }
}